import { Injectable } from '@angular/core';
import { AllowedVal } from '@ntap/core';
import { Observable } from 'rxjs';
import { RefreshableAttributeStateService } from './refreshable-attribute-state.service';

@Injectable()
export class BrziObrazacAttributeStateService extends RefreshableAttributeStateService {
  override getAllowedValues(
    attributeMetadata: any,
    objectData: any,
    viewName: string
  ): Observable<AllowedVal[]> {
    if (attributeMetadata.name === 'en~jedinica_gradiva~razina') {
      return super.getAllowedValues(
        attributeMetadata,
        objectData,
        viewName + '$forceAll'
      );
    } else {
      return super.getAllowedValues(attributeMetadata, objectData, viewName);
    }
  }
}
